import { z } from "zod";

import type { IProperty } from "types/jsonSchema";

export default function parseNumber(field: IProperty) {
    let schema = z.coerce.number();

    if (field?.minLength) schema = schema.min(field.minLength);
    if (field?.maxLength) schema = schema.max(field.maxLength);

    return schema;
}
